export default {
  auth: {
    username: '用户名',
    password: '密码',
    login: '登录',
    logout: '退出'
  },
  general: {
    detail: '详细内容',
    save: '保存',
    cancel: '取消',
    assign: '指派',
    close: '完成',
    submit: '提交'
  },
  route: {
    order: '订单',
    schedule: '预约',
    history: '历史记录'
  },
  schedule: {
    district: '区域',
    coach: '教练',
    schedule: '时间',
    vehicle: '车辆',
    start_address: '上车地址',
    end_address: '下车地址',
    notes: '备注'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js